import { render, staticRenderFns } from "./promotes.vue?vue&type=template&id=2bf7f546"
import script from "./promotes.vue?vue&type=script&lang=js"
export * from "./promotes.vue?vue&type=script&lang=js"
import style0 from "./promotes.vue?vue&type=style&index=0&id=2bf7f546&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports